import { Dropdown, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect } from "react";
import { WizarContext } from "contexts/WizardContext";
import { singleOtherAddressesInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

const OtherAddressesInfo = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  let otherAddresses = state.single.otherAddressesInfo;
  let otherAddressInfoErrors = errors.single.otherAddressesInfo;
  let changState = useCallback((payload) => dispatch(singleOtherAddressesInfoActionCreator(payload)), [dispatch]);
  const resetInputFieldError = (property) => {
    if (errors.single.otherAddressesInfo[property]) {
      setErrors((errorsState) => ({
        ...errorsState,
        single: {
          ...errorsState.single,
          otherAddressesInfo: { ...errorsState.single.otherAddressesInfo, [property]: "" },
        },
      }));
    }
  };

  const { user } = useContext(GlobalContext);
  const userId = user.siaId;

  const setUserSession = (obj) => {
    webPlatformAdapter.getWizardSession(userId, (data) => {
      const updatedSession = { ...data, otherAddressesInfo: { ...data.otherAddressesInfo, ...obj } };
      webPlatformAdapter.setWizardSession(userId, { ...updatedSession });
    });
  };

  useEffect(() => {
    if (userId) {
      webPlatformAdapter.getWizardSession(userId, (data) => {
        const defaultOtherAddressInfo = { ...initialWizardFormState.single.otherAddressesInfo };
        const { otherAddressesInfo } = data;
        const { contact, delivery, invoice } = otherAddressesInfo || defaultOtherAddressInfo;
        changState({
          contact,
          delivery,
          invoice,
        });
      });
    }
  }, [userId, changState]);
  const langauges = [
    { label: "DE", id: "de" },
    { label: "FR", id: "fr" },
    { label: "IT", id: "it" },
    { label: "EN", id: "en" },
  ];

  return (
    <div className="otherAddresses-info-page">
      <p className="sia-text-11 sia-margin-03-bottom">{translate("wizard.form.single.delivery-address.info")}</p>
      <Dropdown
        id={"otherAddresses-page-contact"}
        label={translate("wizard.form.single.delivery-address.contact.label")}
        items={langauges}
        value={otherAddresses.contact}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("contact");
          changState({ contact: value });
          setUserSession({ contact: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={otherAddressInfoErrors.contact}
        invalidText={otherAddressInfoErrors.contact}
      />
      <Dropdown
        id={"otherAddresses-page-delivery"}
        label={translate("wizard.form.single.delivery-address.deleviry.label")}
        items={langauges}
        value={otherAddresses.delivery}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("delivery");
          changState({ delivery: value });
          setUserSession({ delivery: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={otherAddressInfoErrors.delivery}
        invalidText={otherAddressInfoErrors.delivery}
      />
      <Dropdown
        id={"otherAddresses-page-invoice"}
        label={translate("wizard.form.single.delivery-address.invoice.label")}
        items={langauges}
        value={otherAddresses.invoice}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("invoice");
          changState({ invoice: value });
          setUserSession({ invoice: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={otherAddressInfoErrors.invoice}
        invalidText={otherAddressInfoErrors.invoice}
      />
    </div>
  );
};

export default OtherAddressesInfo;
